// Common API's
const GetWorkOrderTypesAndCategories = 'Common/GetWorkOrderTypesAndCategories'
const GetWorkorderStages = 'Common/GetWorkorderStages'
const GetCountryStates = 'Common/GetCountryStates'
const GetDocumentTemplateData = 'Common/GetDocumentTemplateData'
const GetVesselByOfficialNumber = 'Common/GetVesselByOfficialNumber'
const GetSearchAgent = 'Common/SearchAgents'
const GetAgentDetailsById = "Common/GetAgentDetailsById"
const GetCustomerCompanyDetails = 'Common/GetAgentsByEmail'
const GetSupportingDocuments = 'Common/GetSupportingDocuments'
const SendFeedbackEmail = 'Common/SendFeedbackEmail'

// Dashboard API's
const GetCustomerWorkorders = 'Dashboard/GetCustomerWorkorders'
const FilterWorkorders = 'Dashboard/FilterWorkorders'
const GetVesselDashboard = 'getVesselDashboard'
const GetTotalInvoiceRevenue = 'Dashboard/GetTotalInvoiceRevenue'

// Company API's
const GetSFCompaniesByName = 'Company/GetSFCompaniesByName'
const CreateCompany = 'Company/CreateCompany'
const GetCompanyDetails = 'Company/GetSFRCompanyList'
const GetParentCompany = 'GetParentCompany'
const ValidateClient = 'ValidateClient'
const ValidateWorkorderCreation = 'ValidateWorkorderCreation'

// Workorders API's
const GetBaseWorkOrderData = 'GetBaseWorkOrderData'
const CreateWorkorder = 'CreateWorkorder'
const UpdateWorkorderData = 'UpdateWorkorderData'
const GetWorkorderById = 'GetWorkorderById'
const UpdateWorkorder = 'UpdateWorkorder'
const RemoveWorkorderDocument = 'FileUpload/RemoveWorkorderDocument'
const RequestMoreInfo = 'RequestMoreInfo'
const GetInvoiceDocument = 'GetInvoiceDocument'
const GetcasInvoiceDocument = 'GetcasInvoiceDocument'
const GetPreviewDocument = 'PreviewAuthorizationDocument'
const UpdateNeedMoreInfoStatus = 'UpdateNeedMoreInfoStatus'
const CancelWorkorder = 'CancelWorkorder'
const ArchivedWorkorder = 'ArchivedWorkorder'
const ResendDocusignEmail = 'ResendDocusignEmail'
const SendAcknowledgementMail = 'SendAcknowledgementMail'
const GetAuthorizationDocument = 'GetAuthorizationDocument'
const ValidateVesselDetails = 'ValidateVesselDetails'
const GetWorkOrderFilesByFileId = 'FileUpload/GetWorkOrderFilesByFileId'
const GetCompanyAddressdetails = 'Company/GetCompanyAddressdetails'
const ValidateAgentName = 'ValidateAgentName'
const GetProductCodes = 'GetProductCodes'
const AddorRemoveProformaInvoice = 'AddorRemoveProformaInvoice'
const UpdateProductCodes = 'UpdateProductCodes'

// Workorder Comments Api's
const GetWorkorderComments = 'WorkorderComment/GetWorkorderComments'
const CreateComment = 'WorkorderComment/CreateComment'

// IHM SOC API's
const GetAllVesselsByAccountId = 'GetAllVesselsByAccountId'
const ResendEmails = 'ResendEmails'
const UpdateBillingPrefix = 'UpdateBillingPrefix'
const UpdateResendEmail = 'ResendEmail'
const RegenerateAuthorizationLetter = 'RegenerateAuthorizationLetter'
const UpdateNdaDocument = 'UpdateNdaDocument'
const GetVesselSyncData = 'GetVesselSyncData'

// Seafarer API's
const ValidateSCDUserDetails = 'ValidateSCDUserDetails'
const GetAgentDetailsByAgentNumber = 'GetAgentDetailsByAgentNumber'
const ValidateAgentNumber = 'ValidateAgentNumber'
const GetSFRCompaniesByName = 'GetSFRCompaniesByName'
const GetSFRCompanies = 'GetSFRCompanies'
const RetryAddAgentContact = 'RetryAddAgentContact'
const GetFilesDataByFolderName = 'FileUpload/GetFilesDataByFolderName'
const DownloadDocument = 'FileUpload/DownloadDocument'
const DeleteDocument = 'FileUpload/DeleteDocument'
const GetCASSupportingDocuments = 'Common/GetSupportingDocuments'
const GetCasAgreemet = 'GetCasAgreement'

const GetListFiles = "GetListFiles"
const GetAllActiveVaultsForUser = "GetActiveVaultsForUser"
const UpdateCustomerVault = "UpdateCustomerVault"
const DownloadFile = "DownloadFile"
const GetCompanyAddress = "Company/GetCompanyAddress"
const GetLastModifiedFiles = "GetLastModifiedFiles"
const GetSearchLibrary = "SearchLibrary"
const RefreshVesselData = "RefreshVesselData"

export const ApiUrls = {
  GetWorkOrderTypesAndCategories,
  GetWorkorderStages,
  GetCountryStates,
  GetDocumentTemplateData,

  GetCustomerWorkorders,
  FilterWorkorders,
  GetVesselDashboard,
  GetCompanyDetails,
  GetCustomerCompanyDetails,
  GetParentCompany,
  ValidateClient,

  GetSFCompaniesByName,
  CreateCompany,
  ValidateWorkorderCreation,
  GetSFRCompaniesByName,
  GetSFRCompanies,
  GetBaseWorkOrderData,
  GetAgentDetailsByAgentNumber,
  ValidateAgentNumber,
  CreateWorkorder,
  UpdateWorkorderData,
  GetWorkorderById,
  UpdateWorkorder,
  RemoveWorkorderDocument,
  RequestMoreInfo,
  GetInvoiceDocument,
  GetcasInvoiceDocument,
  GetPreviewDocument,
  UpdateNeedMoreInfoStatus,
  CancelWorkorder,
  ArchivedWorkorder,
  ResendDocusignEmail,
  SendAcknowledgementMail,
  ValidateVesselDetails,
  GetWorkOrderFilesByFileId,
  GetCompanyAddressdetails,
  GetWorkorderComments,
  CreateComment,

  GetAuthorizationDocument,
  GetAllVesselsByAccountId,
  GetVesselByOfficialNumber,
  ValidateSCDUserDetails,
  ResendEmails,
  UpdateBillingPrefix,
  UpdateResendEmail,
  RegenerateAuthorizationLetter,
  GetListFiles,
  GetAllActiveVaultsForUser,
  UpdateCustomerVault,
  DownloadFile,
  GetCompanyAddress,
  GetLastModifiedFiles,
  GetSearchLibrary,
  UpdateNdaDocument,
  GetVesselSyncData,
  RetryAddAgentContact,
  GetFilesDataByFolderName,
  DownloadDocument,
  DeleteDocument,
  GetSearchAgent,
  GetAgentDetailsById,
  GetCASSupportingDocuments,
  GetCasAgreemet,
  RefreshVesselData,
  GetTotalInvoiceRevenue,
  GetSupportingDocuments,
  SendFeedbackEmail,
  ValidateAgentName,
  GetProductCodes,
  AddorRemoveProformaInvoice,
  UpdateProductCodes
}
